<template>
  <b-container fluid>
    <b-col md="6">
      <div class="card">
        <div class="card-header">
          Account Created
        </div>
        <div class="card-body">
          <form>
            <p>
              You can now <router-link to="/">Log in</router-link> to your Vos Voco account.
            </p>
            <p v-if="invited">
              To see your teams and choose notification preferences, log in then click on the menu in the top right and select 'Personal Settings'.
            </p>
            <p v-else>
              To manage your account and add more users, log in then click on the menu in the top right and select 'Manage Users, Teams & Permissions'.
            </p>
            <p>
              You can also now log in to the Vos Voco app. You can download it here:
            </p>
            <div>
              <a href="https://apps.apple.com/gb/app/vos-voco/id1320905130?mt=8">
                <img class="ios" src="https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2017-12-06&kind=iossoftware&bubble=ios_apps" alt="Download on the App Store"/>
              </a>
              <a href='https://play.google.com/store/apps/details?id=com.vosvoco.Maple&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                <img class="android" alt='Get it on Google Play' src='https://play.google.com/intl/en_gb/badges/static/images/badges/en_badge_web_generic.png'/>
              </a>
            </div>
          </form>
        </div>
      </div>
    </b-col>
  </b-container>
</template>

<script>
export default {
  name: 'AccountCreated',
  data () {
    return {
      invited: (this.$route.query.invited != null && this.$route.query.invited !== '')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img.android {
  width: 150px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/AccountCreated.vue